import type { AiCatalogItemDto } from '@core/api/workspace/models/aiCatalogItemDto';
import type { FieldCatalogItem } from './form-field-catalog';

export function toAiCatalogPayload(
  catalog: FieldCatalogItem[],
): AiCatalogItemDto[] {
  return catalog.map((item) => ({
    id: item.id,
    label: item.label,
    description: item.description,
    category: item.category,
  }));
}
